import { render } from "./ResourceTable.vue?vue&type=template&id=4d6a1cc7"
import script from "./ResourceTable.vue?vue&type=script&lang=js"
export * from "./ResourceTable.vue?vue&type=script&lang=js"
script.render = render

export default script